var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table__heading"},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"20","color":_vm.iconColor}},[_vm._t("icon")],2),_c('h1',{staticClass:"table-title"},[_vm._t("title")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }